import { ManageFunctionComponent } from './../manage-function/manage-function.component';
import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { ManageDocumentConfig } from './shared/manage-document.config';
import { ManageDocumentDataService } from './shared/manage-document.data.service';
import { LocalDataSource } from 'ng2-smart-table';
import { DocumentoAsociarTarea, Tarea, DefaultDocument } from '@app/shared';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-manage-document',
  templateUrl: './manage-document.component.html',
  styleUrls: ['./manage-document.component.scss'],
  providers: [ ManageDocumentDataService ]
})
export class ManageDocumentComponent implements OnInit, OnDestroy {
  @Input() sourceTask: Tarea;

  // Configuracion de la tabla
  settings = {};
  // Contiene los documentos
  source: DefaultDocument[] = [];
  // Contiene los datos de la tabla previamente seteados y listos para renderizar en la tabla
  sourceData: LocalDataSource;
  // documentos asociados a la tarea
  documentsAssociates: Array<DocumentoAsociarTarea> = [];
  // documento asociado seleccionado
  documentSelectFunction: DocumentoAsociarTarea;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de el modal de acciones de la tabla
  @ViewChild('modalTable') private modalTable: ManageFunctionComponent;

  constructor(private mdds: ManageDocumentDataService) { }

  ngOnInit() {
    if (this.sourceTask) {
      this.sourceTask.documentos.forEach(document => {
        this.documentsAssociates.push({
          documento: document['documento'] ? document['documento'] : document.documento,
          clasificacion: document.clasificacion,
          tipo_documental: document.tipo_documental,
          funciones: document.funciones
        });
      });
    }
    const docsC = new ManageDocumentConfig();
    this.settings = docsC.settings;
    docsC.accion.subscribe((data: any) => {
      this.actionTable(data);
    });
    this.mdds.getDefaultDocuments().subscribe(data => {
      this.source = data;
      this.loadingDocuments();
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga los documentos y setea la informacion
   *
   * @memberof ManageDocumentComponent
   */
  loadingDocuments(refres: boolean = true) {
    this.source.forEach((sourceD: any) => {
      sourceD.associate = 'No';
    });

    if (this.documentsAssociates.length > 0) {
      this.source.forEach((sourceD: any) => {
        this.documentsAssociates.forEach(documentA => {
          if (documentA.documento === sourceD.id) {
            sourceD.associate = 'Sí';
          }
        });
      });
    }
    if (refres) {
      this.sourceData = new LocalDataSource(this.source);
    }
    this.sourceData.refresh();
  }

  /**
   * Controla las acciones de la tabla
   *
   * @param {*} data
   * @memberof ManageDocumentComponent
   */
  async actionTable(data: any) {
    switch (data.action) {
      case 'asociar':
        this.documentsAssociates.push({
          documento: data.row.id,
          clasificacion: data.row.nombre,
          tipo_documental: data.row.tipo_documental,
          funciones: []
        });
        this.loadingDocuments(false);
        break;
      case 'eliminar':
        for (let index = 0; index < this.documentsAssociates.length; index++) {
          if (this.documentsAssociates[index].documento === data.row.id) {
            this.documentsAssociates.splice(index, 1);
          }
        }
        this.loadingDocuments(false);
        break;
      case 'funciones':
        await this.documentsAssociates.forEach(document => {
          if (document.documento === data.row.id) {
            this.documentSelectFunction = document;
            this.modalTable.document = document;
          }
        });
        this.modalTable.open();
        break;
    }
  }

  /**
   * Guarda las funciones agregadas al documento asociado correspondiente
   *
   * @param {DocumentoAsociarTarea} funtionsDocument
   * @memberof ManageDocumentComponent
   */
  saveFuntion(funtionsDocument: DocumentoAsociarTarea) {
    this.documentsAssociates.forEach(document => {
      if (document.documento === funtionsDocument.documento) {
        document.funciones = funtionsDocument.funciones;
      }
    });
  }

  /**
   * Retorna los documentos asociados
   *
   * @returns
   * @memberof ManageDocumentComponent
   */
  getDocument() {
    if (this.documentsAssociates) {
      return this.documentsAssociates;
    } else {
      return [];
    }
  }

  /**
   * Limpiar componente
   *
   * @memberof ManageDocumentComponent
   */
  empty() {
    this.documentsAssociates = [];
    this.loadingDocuments();
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/basic-process-configuration/manage-document/manage-document.component.ts